export default __webpack_public_path__ + "static/media/style3.73cc3f50.svg";